import JwtService from './jwtService';

export { JwtClass } from './jwtService';
export default JwtService;